import { c } from "react/compiler-runtime";
import { mapGaugeProps } from "../../utils/cardProps.js";
import useReportTranslations from "../useReportTranslations.js";
import useCardGoals from "./useCardGoals.js";
const useGaugeProps = (config, data) => {
  const $ = c(5);
  const {
    translate
  } = useReportTranslations();
  const goalsData = useCardGoals(config.goals);
  let t0;
  if ($[0] !== config || $[1] !== data || $[2] !== goalsData || $[3] !== translate) {
    t0 = mapGaugeProps(config, data ?? {}, {
      translate,
      goalsData
    });
    $[0] = config;
    $[1] = data;
    $[2] = goalsData;
    $[3] = translate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
export { useGaugeProps as default };